module.exports = __webpack_public_path__ + "static/media/orange-tabby-cat.188b1284.png";